import * as actionTypes from '../actions/actionTypes';

export default function customerIncorrectCredentials(state = {}, action) {
    switch(action.type){
      case actionTypes.SET_INCORRECT_CUSTOMER:
        return {
          ...state,
          ...action.flag
        }
        case actionTypes.RESET_INCORRECT_CUSTOMER : {
          return {};
        }

      default: return state;

    }
}



// WEBPACK FOOTER //
// ./src/components/layouts/reducers/incorrectCustomer.js